import React, { useEffect, useRef, useState } from "react";
import styles from "./Menu.module.css";
import ShowEarlyWarning from "../../mainLayer/earlyWarning/ShowEarlyWarning";

type MenuItemPropType = {
  id: number;
  title: string;
  img: string;
};

type MenuTabPropsType = {
  id: number;
  title: string;
  type: string;
  itemDetails: Array<MenuItemPropType>;
  popupLayerType: string;
  setOpenTab: (id: number) => void;
  openTabId: number | null;
  passClickedEWSValue: (clicked: boolean) => void;
  sensorType: (value: string) => void;
  openModular: (value: string) => void;
  renderEWS: (value: boolean) => void;
 
};

const EarlyWarningItem = ({
  id,
  title,
  type,
  itemDetails,
  popupLayerType,
  setOpenTab,
  openTabId,
  passClickedEWSValue,
  sensorType,
  openModular,
  renderEWS,
 
}: MenuTabPropsType) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
  const [itemList, setItemList] =
    useState<Array<MenuItemPropType>>(itemDetails);
  const isUserToggled = useRef<boolean>(false);

  useEffect(() => {
    setIsMenuOpen(popupLayerType === title);
    if (popupLayerType === title) {
      setOpenTab(id);
    }
  }, [popupLayerType, title]);

  useEffect(() => {
    if (openTabId !== id) {
      // setIsMenuOpen(false);
    }
  }, [openTabId]);

  const TabToggleSwitch = () => {
    setIsMenuOpen((prevState) => !prevState);
    setOpenTab(id);
    // isUserToggled.current = true;
  };

  const dragItem = useRef<number>(0);
  const dragOver = useRef<number>(0);

  const handleSort = () => {
    const layerList = [...itemList];
    const temp = layerList[dragItem.current];
    layerList[dragItem.current] = layerList[dragOver.current];
    layerList[dragOver.current] = temp;
    setItemList(layerList);
  };

  return (
    <div key={id} className={styles.menuTabContainer}>
      <div
        className={styles.titleContainer}
        onClick={TabToggleSwitch}
        onTouchStart={TabToggleSwitch}
        style={{
          backgroundColor: `${
            isMenuOpen ? "var(--menu-tab-open-color)" : "var(--menu-main-color)"
          }`,
        }}
      >
        <img
          src={
            isMenuOpen
              ? require("../../assets/drop.png")
              : require("../../assets/up.png")
          }
          alt=""
        />
        <span>{title}</span>
      </div>
      <div
        className={styles.contentContainer}
        style={{
          height: `${isMenuOpen ? "150px" : "0.4px"}`,
          flexDirection: `${
            type === "basecamp" || type === "projection" ? "row" : "column"
          }`,
          justifyContent: `${
            type === "basecamp" || type === "projection" ? "center" : ""
          }`,
          padding: `${
            (type === "basecamp" || type === "projection") && isMenuOpen
              ? "10px"
              : "0"
          }`,
        }}
      >
        {type === "overlay" &&
          itemDetails?.map((item) => (
            <ShowEarlyWarning
              key={item.id}
              id={item.id}
              title={item.title}
              passClickedEWSValue={passClickedEWSValue}
              menuOpen={isMenuOpen}
              sensorType={sensorType} openModular={openModular} renderEWS={renderEWS}
            />
          ))}
      </div>
    </div>
  );
};

export default EarlyWarningItem;
